import React from 'react'
import {BlockProps} from '../atoms/blockList'
import {RichTextBlockExampleValue} from './types'
import {TipTapBlock, emptyTipTapValue} from '@dudagroup/editor'
import {Col, Row, SelectPicker, Form} from 'rsuite'
import {ContentModelSchemaFieldRichText, ContentModelSchemaFieldTipTap} from '@dudagroup/api'
import {SlateReference} from './slateReference'
import {useTranslation} from 'react-i18next'

export type RichTextBlockProps = BlockProps<RichTextBlockExampleValue>
export function RichTextBlockExampleBlock({
  value,
  onChange,
  model,
  autofocus,
  disabled,
  languageLaneL,
  languageLaneR,
  langUi,
  configs,
}: RichTextBlockProps) {
  const {text, tiptap, backgroundColor} = value
  const {t} = useTranslation()
  const data = (model.fields.backgroundColor as any).values.map((item: any) => {
    return {
      label: item.description,
      value: item.value,
    }
  })
  return (
    <>
      <Row className="show-grid" style={{display: 'flex', alignItems: 'center', marginBottom: 24}}>
        <Col xs={14}>
          <Form.ControlLabel style={{marginRight: 10}}>
            {t('blockList.backgroundColor')}
          </Form.ControlLabel>
          <SelectPicker
            style={{width: '100%'}}
            data={data}
            value={backgroundColor}
            searchable={false}
            onChange={(val) => {
              onChange(val, ['backgroundColor'])
            }}
          />
        </Col>
      </Row>
      {/*
        The TipTap field holds the block's text since the cutover (RESNF-752);
        the Slate `text` field is hidden and frozen. The left lane edits the
        current language, the right lane shows the second language read-only,
        as the Slate editor did.

        `tiptap` is absent on newly added blocks, so guard before indexing by
        language.
      */}
      <Row className="show-grid" style={{display: 'flex', alignItems: 'top', marginBottom: 24}}>
        <Col xs={14} style={{padding: 0}}>
          <TipTapBlock
            languageContext={{
              langLane1: languageLaneL,
              langLane2: languageLaneR,
              langUi: langUi,
              languagesConfig: configs.apiConfig.languages,
            }}
            config={(model.fields.tiptap as ContentModelSchemaFieldTipTap).config}
            value={(tiptap ?? {})[languageLaneL] || emptyTipTapValue()}
            onChange={(val) => {
              onChange(val, ['tiptap', languageLaneL])
            }}
            autofocus={autofocus}
            disabled={disabled}
          />
        </Col>
        <Col xs={1} style={{textAlign: 'center', paddingTop: '5px'}}></Col>
        <Col xs={9}>
          <TipTapBlock
            languageContext={{
              langLane1: languageLaneL,
              langLane2: languageLaneR,
              langUi: langUi,
              languagesConfig: configs.apiConfig.languages,
            }}
            config={(model.fields.tiptap as ContentModelSchemaFieldTipTap).config}
            value={(tiptap ?? {})[languageLaneR] || emptyTipTapValue()}
            onChange={() => {
              // read-only reference lane
            }}
            autofocus={false}
            displayOnly={true}
            disabled={true}
          />
        </Col>
      </Row>
      <SlateReference
        field={model.fields.text as ContentModelSchemaFieldRichText}
        value={text}
        languageContext={{
          langLane1: languageLaneL,
          langLane2: languageLaneR,
          langUi: langUi,
          languagesConfig: configs.apiConfig.languages,
        }}
      />
    </>
  )
}
